<template>
  <div class="OpenRecoCard">
    <div class="hero-section">
      <h1>Market Place For Price Estimates</h1>
      <p>Discover, Validate & Trade On StockAnts</p>
      <div class="tabs">
        <button :class="{ active: activeTab === 'equity' }" @click="activeTab = 'equity'">Equity</button>
        <button :class="{ active: activeTab === 'options' }" @click="activeTab = 'options'">Options</button>
      </div>
    </div>
    <div class="reco-card-section">
      <div class="img-outer">
        <div class="recoListSection">
          <div class="stock-data-section" :class="websiteUserType.userSubType != 'brokerWithoutPlans' ? 'stock-data-section' : 'stock-data-section-second'">
            <!-- Show Equity Recommendations -->
            <RecommendationDetailsCard v-if="activeTab === 'equity'" :recommendationsList="past_reco_track_list"></RecommendationDetailsCard>
            <!-- Bottom locked section for Equity -->
            <div class="locked-bottom-section" v-if="isLocked">
              <div class="lock-overlay">
                <img src="../assets/images/Lock.svg" alt="Locked" class="lock-icon" />
                <br />
                <button class="unlock-btn" @click="signUp()">Sign Up for Free</button>
              </div>
            </div>
            <!-- Show Options Recommendations -->
            <StrategyCard v-if="activeTab === 'options'" :recommendationsList="options_reco_track_list"></StrategyCard>
            <!-- Bottom locked section for Options -->
            <div class="locked-bottom-section" v-if="isLocked">
              <div class="lock-overlay">
                <img src="../assets/images/Lock.svg" alt="Locked" class="lock-icon" />
                <br />
                <button class="unlock-btn" @click="signUp()">Sign Up for Free</button>
              </div>
            </div>
          </div>

          <div :class="{ 'infinite-loader-top-position': page_no == 1 }" v-if="is_list_loading">
            <div class="text-center">
              <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px" />
            </div>
          </div>

          <!-- No Data State -->
          <div v-if="!is_list_loading && !past_reco_track_list.length && activeTab === 'equity'">
            <NoDataFound></NoDataFound>
          </div>
          <div v-if="!is_list_loading && !options_reco_track_list.length && activeTab === 'options'">
            <NoDataFound></NoDataFound>
          </div>
        </div>

        <div class="one-click-title">
          Unlock Multiple Opportunities At
          <br />
          <span>one click</span>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import { screenSize } from '../mixins/ScreenSize';

import { serverAddr } from '../networkConfig';
import RecoActionButtons from '@/components/RecoActionButtons.vue';
import NoDataFound from '@/components/NoDataFound.vue';
import { EventBus } from '../eventBus';
import RecommendationDetailsCard from '@/components/RecoCardPreSignUp.vue';
import StrategyCard from '@/components/StrategyCardPreSignUp.vue';
import { HelperNetworkCallBack } from '../mixins/Helper';
import moment from 'moment';
import CripNotice from 'crip-vue-notice';

export default {
  name: 'OpenRecoCard',
  mixins: [HelperNetworkCallBack, screenSize],
  components: {
    NoDataFound,
    RecommendationDetailsCard,
    StrategyCard,
  },

  data() {
    return {
      activeTab: 'equity',
      screenSize: window.innerWidth,
      past_reco_track_list: [], // For Recommendation
      options_reco_track_list: [], // For strategy
      stock_list: '',
      page_no: 1,
      reco_loading: false,
      reco_price_market: '',
      userProfile: {},
      websiteUserType: localStorage.getItem('websiteUserType') ? JSON.parse(localStorage.getItem('websiteUserType')) : {},
      currentEnvironment: {},
      isLocked: true,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem('profile') && !Object.keys(to.query).length) {
      next('/data-categorisation'); // Redirect using next
    } else {
      next(); // Continue with the navigation
    }
  },
  beforeCreate() {
    // get currentEnvironment details
    if (!localStorage.getItem('profile')) {
      setTimeout(() => {
        if (localStorage.getItem('currentEnvironment')) {
          var currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));

          if (currentEnvironment.utm_source && (currentEnvironment.utm_source == 'Nirman' || currentEnvironment.utm_source == 'Choice')) {
            this.$router.push('/');
          } else if (currentEnvironment.byPassLogin) {
            this.$router.push('/auth-bypass');
          }
        }
      }, 0);
    }
  },
  watch: {
    // screenSize(newValue, oldValue) {
    // },
  },
  created() {
    //get all short term reco data track
    this.getAllPastRecoList();
    this.getAllOptionsRecoList();
  },
  mounted() {
    if (localStorage.getItem('profile')) {
      this.userProfile = JSON.parse(localStorage.getItem('profile'));
    }
    // after logout save currentUrl
    if (!localStorage.getItem('currentUrl') || this.userProfile) {
      this.selectUserType();
    }

    if (localStorage.getItem('currentEnvironment')) {
      this.currentEnvironment = JSON.parse(localStorage.getItem('currentEnvironment'));
    }
    window.addEventListener('resize', this.updateScreenSize);
  },
  methods: {
    // Fetch past recommendations for the Equity tab
    getAllPastRecoList() {
      this.is_list_loading = true;
      serverAddr
        .post('/recommendation/v1/open_api/read_recommendation', {
          page_no: this.page_no,
          page_per_entries: 1,
        })
        .then((response) => {
          if (response.data.status) {
            this.is_list_loading = false;

            response.data.data.forEach((element, index) => {
              this.$set(element, 'logic_description', element.report.length ? element.report[0].description : '');
              this.past_reco_track_list.push(response.data.data[index]);
            });
          } else {
            this.is_list_loading = false;
            this.past_reco_track_list = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_list_loading = false;
        });
    },

    // Fetch options recommendations
    getAllOptionsRecoList() {
      this.is_list_loading = true;
      serverAddr
        .post('/options/open_api/opinion/market', {
          page_no: this.page_no,
          page_per_entries: 1,
        })
        .then((response) => {
          if (response.data.status) {
            this.is_list_loading = false;
            this.options_reco_track_list = response.data.data;
          } else {
            this.is_list_loading = false;
            this.options_reco_track_list = [];
          }
        })
        .catch((error) => {
          console.log(error);
          this.is_list_loading = false;
        });
    },
    signUp() {
      this.$router.push({ name: 'login', params: { plan: 'register' } });
    },
    updateScreenSize() {
      this.screenSize = window.innerWidth;
    },
  },

  beforeDestroy() {
    EventBus.$off();
  },
};
</script>
    
<style scoped lang="scss">
@import '../css/variable.scss';
@import '../css/common.scss';

.OpenRecoCard {
  .hero-section {
    text-align: center;
    padding: 20px 40px;
    margin-top: 30px;
    h1 {
      font-size: 45px;
      font-weight: 800;
      color: $secondary-theme-color;
      margin-bottom: 10px;
    }
    p {
      margin-top: 0;
      font-size: 15px;
      font-weight: 600;
    }
    .tabs {
      margin-top: 20px;
      button {
        font-weight: 600;
        padding: 8px 20px;
        font-size: 12px;
        margin: 7px;
        border: none;
        border-radius: 15px;
        cursor: pointer;
        border: 1px solid #e1dfdf;
        color: #adadad;
      }
    }

    .tabs .active {
      background-color: $primary-theme-color;
      color: white;
    }
  }
  .reco-card-section {
    background-image: url('../assets/images/LitePlanExpertView/BackGroundImage.svg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    text-align: center;
    margin-top: 40px;
    // min-height: 265px;
    .img-outer {
      position: relative;
      bottom: 35px;
      display: block;
      margin: 0px 100px;
      text-align: left;
      img {
        width: 80%;
        cursor: pointer;
        margin: 0 auto;
      }
      .one-click-title {
        color: #ffff;
        font-size: 20px;
        font-weight: 600;
        margin-top: 15px;
        text-align: center;
        span {
          font-size: 60px !important;
          text-transform: uppercase;
          font-weight: 800;
        }
      }
    }
  }
  .stock-data-section {
    padding-top: 0px !important;
    min-height: 200px;
  }
  .lock-overlay {
    position: absolute;
    top: 110px !important;
    left: 5px;
    right: 5px;
    bottom: 110px !important;
    backdrop-filter: blur(3px); /* Apply blur only to background */
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .lock-content {
    position: relative; /* Ensures no blur effect is applied */
    z-index: 2; /* Higher than the blurred background */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .lock-icon {
    width: 50px;
    height: 50px;
    margin-bottom: 12px;
  }

  .unlock-btn {
    width: 180px; /* Button width */
    background-color: #2d2e8d;
    color: white;
    font-size: 15px;
    font-weight: 600;
    border: none;
    padding: 10px 16px;
    border-radius: 10px;
    cursor: pointer;
    transition: background 0.3s;
    display: flex;
    justify-content: center; /* Center text horizontally */
  }

  .unlock-btn:hover {
    background-color: #25267d;
  }

  @media screen and (max-width: 1100px) {
    .lock-overlay {
      top: 100px !important;
      bottom: 130px !important;
    }
  }
  @media screen and (max-width: 860px) {
    .hero-section h1 {
      font-size: 30px;
    }
  }
  @media screen and (max-width: 768px) {
    .reco-card-section {
      margin-top: 30px;
      .img-outer {
        margin: 0px;
        img {
          width: 300px;
        }
        .one-click-title {
          font-size: 15px;

          span {
            font-size: 40px !important;
            text-transform: uppercase;
            font-weight: 800;
          }
        }
      }
    }
    .lock-overlay {
      top: 100px !important;
      bottom: 100px !important;
    }
  }
  @media screen and (max-width: 610px) {
    .hero-section {
      h1 {
        font-size: 25px;
      }
      p {
        font-size: 10px;
      }
    }

    .lock-overlay {
      top: 106px !important;
      bottom: 95px !important;
    }
  }
}
</style>